import Budget from '../Components/Sheets/Budget/Budget'

export default function BudgetPage () {
  return (
    <Budget />
  )
}
